var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulb = function SvgBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bulb_svg__a)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M2.143 13A7.8 7.8 0 0 1 1 8.919C1 4.545 4.582 1 9 1s8 3.545 8 7.919A7.8 7.8 0 0 1 15.857 13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bulb_svg__b)",
    strokeWidth: 1.5,
    d: "M4.383 16.098c-.092-.276-.138-.415-.133-.527a.6.6 0 0 1 .382-.53c.104-.041.25-.041.54-.041h7.656c.291 0 .436 0 .54.04a.6.6 0 0 1 .382.531c.005.112-.041.25-.133.527-.17.511-.255.767-.386.974a2 2 0 0 1-1.2.869c-.238.059-.506.059-1.043.059H7.012c-.537 0-.805 0-1.043-.06a2 2 0 0 1-1.2-.868c-.131-.207-.216-.463-.386-.974Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bulb_svg__c)",
    strokeWidth: 1.5,
    d: "m12 18-.13.647c-.14.707-.211 1.06-.37 1.34a2 2 0 0 1-1.113.912C10.082 21 9.72 21 9 21s-1.082 0-1.387-.1a2 2 0 0 1-1.113-.913c-.159-.28-.23-.633-.37-1.34L6 18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bulb_svg__d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.25 8.75 7.5 11v4M5.25 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bulb_svg__e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.75 8.75 10.5 11v4m2.25-5.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bulb_svg__a",
    x1: 9,
    x2: 9,
    y1: 1,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bulb_svg__b",
    x1: 9,
    x2: 9,
    y1: 15,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bulb_svg__c",
    x1: 9,
    x2: 9,
    y1: 18,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bulb_svg__d",
    x1: 4.5,
    x2: 7.5,
    y1: 11.5,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bulb_svg__e",
    x1: 10.5,
    x2: 13.5,
    y1: 11.5,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })))));
};
export default SvgBulb;